import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ContactForm.css";

const ContactForm = () => {
  // --- CAPTCHA Setup ---
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);

  useEffect(() => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
  }, []);

  // --- Formular-State ---
  const [formData, setFormData] = useState({
    companyName: "",
    companyWebsite: "",
    zip: "",
    city: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    privacy: false,
    honeypot: "",
    captcha: "",
    formLoadTime: Date.now(),
  });

  const [formStatus, setFormStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus("Prüfe Eingaben...");

    // --- Client-seitige Validierung ---
    if (formData.honeypot) {
      setFormStatus("Fehler: Spam-Verdacht.");
      setIsSubmitting(false);
      return;
    }

    const timeElapsed = (Date.now() - formData.formLoadTime) / 1000;
    if (timeElapsed < 3) {
      setFormStatus("Fehler: Anfrage zu schnell gesendet.");
      setIsSubmitting(false);
      return;
    }

    if (parseInt(formData.captcha, 10) !== num1 + num2) {
      setFormStatus("Fehler: Die Rechenaufgabe ist nicht korrekt gelöst.");
      setIsSubmitting(false);
      return;
    }

    if (!formData.privacy) {
      setFormStatus("Bitte stimmen Sie der Datenschutzerklärung zu.");
      setIsSubmitting(false);
      return;
    }

    try {
      setFormStatus("Anfrage wird sicher gesendet...");

      // Sende die Daten als JSON an dein PHP-Gateway
      const response = await axios.post(
        "/api/gateway.php",
        formData, // Das State-Objekt direkt senden
        {
          headers: {
            "Content-Type": "application/json", // Expliziter Header
          },
        },
      );

      if (response.data.success) {
        setFormStatus("Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet.");
        setFormData({
          companyName: "",
          companyWebsite: "",
          zip: "",
          city: "",
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
          privacy: false,
          honeypot: "",
          captcha: "",
          formLoadTime: Date.now(),
        });

        setNum1(Math.floor(Math.random() * 10) + 1);
        setNum2(Math.floor(Math.random() * 10) + 1);
      } else {
        setFormStatus(
          `Fehler: ${response.data.message || "Unbekannter Fehler auf dem Server."}`,
        );
      }
    } catch (error) {
      setFormStatus(
        "Ein technischer Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
      );
      console.error("Gateway-Fehler:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-container">
      <form onSubmit={handleSubmit}>
        {/* --- Honeypot-Feld --- */}
        <div className="honeypot-field" aria-hidden="true">
          <label htmlFor="website_url">Bitte dieses Feld nicht ausfüllen</label>
          <input
            type="text"
            id="website_url"
            name="honeypot"
            tabIndex="-1"
            autoComplete="off"
            value={formData.honeypot}
            onChange={handleChange}
          />
        </div>

        <h3>Kontaktdaten</h3>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="companyName"
                className="form-control"
                placeholder="Firmenname*"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="companyWebsite"
                className="form-control"
                placeholder="Firmenwebseite"
                value={formData.companyWebsite}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                className="form-control"
                placeholder="Vorname*"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="lastName"
                className="form-control"
                placeholder="Nachname*"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="zip"
                className="form-control"
                placeholder="PLZ"
                value={formData.zip}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="text"
                name="city"
                className="form-control"
                placeholder="Ort"
                value={formData.city}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="E-Mail Adresse*"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                className="form-control"
                placeholder="Telefon*"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>

        <h3>Daten zu der Anfrage</h3>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <textarea
                name="message"
                className="form-control"
                rows="6"
                placeholder="Ihre Anfrage"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
        </div>

        {/* --- Lokales CAPTCHA --- */}
        <div className="form-group captcha-group">
          <label htmlFor="captcha">
            Sicherheitsfrage: Was ist {num1} + {num2}?
          </label>
          <input
            type="number"
            id="captcha"
            name="captcha"
            className="form-control"
            value={formData.captcha}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group privacy-group">
          <input
            type="checkbox"
            id="privacy"
            name="privacy"
            checked={formData.privacy}
            onChange={handleChange}
          />
          <label htmlFor="privacy">
            Ich habe die Datenschutzerklärung gelesen und stimme den Bedingungen
            zu.
          </label>
        </div>

        <div className="form-group">
          <div className="button button-red">
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sende..." : "Anfrage Senden"}
            </button>
          </div>
        </div>
        {formStatus && (
          <p className="form-status" id="gesendet">
            {formStatus}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
